import { render, staticRenderFns } from "./VCompaniesListFooter.vue?vue&type=template&id=6607a35c"
import script from "./VCompaniesListFooter.vue?vue&type=script&lang=js"
export * from "./VCompaniesListFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports